import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/locationOrderReport'
import Component from 'components/Reports/LocationOrderReport'

export default createListViewContainer({ actions, selectors: selectors.locationOrderReport })(Component)
